"use client";
// src/lib/i18n.ts

import i18n from 'i18next';
import { initReactI18next } from "react-i18next";

import en from '../locales/en.json'
import fr from '../locales/fr.json'
import de from '../locales/de.json'
import ja from '../locales/ja.json'
import es from '../locales/es.json'
import id from '../locales/id.json'
import it from '../locales/it.json'
import nl from '../locales/nl.json'
import pt from '../locales/pt.json'
import ru from '../locales/ru.json'
import zhCn from '../locales/zh-cn.json'
import ar from '../locales/ar.json'
import da from '../locales/da.json'
import pl from '../locales/pl.json'
import sv from '../locales/sv.json'
import tr from '../locales/tr.json'
import uk from '../locales/uk.json'
import cs from '../locales/cs.json'
import el from '../locales/el.json'
import hu from '../locales/hu.json'
import ko from '../locales/ko.json'
import no from '../locales/no.json'
import ro from '../locales/ro.json'
import fi from '../locales/fi.json'
import hi from '../locales/hi.json'
import hr from '../locales/hr.json'
import th from '../locales/th.json'
import vi from '../locales/vi.json'

const rtlLanguages = ['ar']; // Add only right-to-left languages here
const defaultLanguage = 'en';
const supportedLanguages = [
    'en',
    'ar',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'fi',
    'fr',
    'hi',
    'hr',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sv',
    'th',
    'tr',
    'uk',
    'vi',
    'zh-CN',
];

i18n
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: defaultLanguage,
        supportedLngs: supportedLanguages,
        resources: {
            // XXX: Make sure this is synced with the supported languages in PolarisProvider.tsx
            en: { translation: en },
            fr: { translation: fr },
            de: { translation: de },
            ja: { translation: ja },
            es: { translation: es },
            id: { translation: id },
            it: { translation: it },
            nl: { translation: nl },
            pt: { translation: pt },
            ru: { translation: ru },
            'zh-CN': { translation: zhCn },
            ar: { translation: ar },
            da: { translation: da },
            pl: { translation: pl },
            sv: { translation: sv },
            tr: { translation: tr },
            uk: { translation: uk },
            cs: { translation: cs },
            el: { translation: el },
            hu: { translation: hu },
            ko: { translation: ko },
            no: { translation: no },
            ro: { translation: ro },
            fi: { translation: fi },
            hi: { translation: hi },
            hr: { translation: hr },
            th: { translation: th },
            vi: { translation: vi },
        },
    });

// TODO: Determine if we need to set the document language and direction
// i18n.on('languageChanged', (lng) => {
//     if (document && document.documentElement) {
//         document.documentElement.lang = lng;
//         document.documentElement.dir = rtlLanguages.includes(shortLangCode(lng)) ? 'rtl' : 'ltr';
//     }
// });

i18n.services.formatter!.add('humansize', (value: number, lng: string | undefined, options: any) => {
    // Automatically SI convert the max size to a human readable format
    const preferUnit = ['B', 'kiB', 'MiB', 'GiB', 'TiB'];

    let size = value;
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < preferUnit.length - 1) {
        size /= 1024;
        unitIndex++;
    }

    const language = lng || 'en';

    const unit = preferUnit[unitIndex];
    const unitSize = size.toLocaleString(language, {maximumFractionDigits: 1, minimumFractionDigits: 0});

    return `${unitSize}${unit}`;
});

i18n.services.formatter!.add('friendlyNumber', (value: number, lng: string | undefined, options: any) => {
    const language = lng || 'en';
    if (Number.isNaN(value)) {
        return 'N/A';
    }

    const formatter = new Intl.NumberFormat(language, {
        style: 'decimal', notation: 'standard', useGrouping: false
    });

    return formatter.format(value);
});

i18n.services.formatter!.add('shortNumber', (value: number, lng: string | undefined, options: any) => {
    const language = lng || 'en';
    if (Number.isNaN(value)) {
        return 'N/A';
    }

    const formatter = new Intl.NumberFormat(language, {
        style: 'decimal', notation: 'compact'
    });

    return formatter.format(value);
});

export function shortLangCode(lang: string) {
    return lang.split('-')[0];
}

export { rtlLanguages, defaultLanguage, supportedLanguages };
export default i18n;
